// _resolveType resolver for union type ConversationNotificationType
// see https://www.apollographql.com/docs/apollo-server/schema/unions-interfaces/ for more details on Union types resolvers
export const conversationNotificationTypeUnionResolver = {
    __resolveType(obj, context, info) {
        if (obj.ConversationId) {
            return 'ConversationType';
        } else {
            return 'ConversationInstanceKey';
        }
    },
};
